import * as React from 'react';
import { ThemeProvider as SystemThemeProvider, useTheme as useSystemTheme } from '@mui/system';
import defaultTheme, { getThemeWithVars } from './defaultTheme';
import { jsx as _jsx } from "react/jsx-runtime";
export const useTheme = () => {
  return useSystemTheme(defaultTheme);
};
export default function ThemeProvider({
  children,
  theme: themeInput
}) {
  return /*#__PURE__*/_jsx(SystemThemeProvider, {
    theme: themeInput ? getThemeWithVars(themeInput) : defaultTheme,
    children: children
  });
}